import React, { useState } from 'react';
import Sidebar from './Sidebar';
import housePreview from '../assets/ngoinha1.png';

const SetupSpace = ({ isVisible, onBack, onContinue, onLogout }) => {
  // --- SỬA LỖI: Luôn gọi Hooks ở dòng đầu tiên của component ---
  const [houseName, setHouseName] = useState('My Home');
  
  // --- Sau khi khai báo Hooks xong mới được check điều kiện return ---
  if (!isVisible) return null;

  const suggestions = ['Home', 'Office', 'My happy place'];

  return (
    <div className="dashboard-container">
      {/* Tái sử dụng Sidebar */}
      <Sidebar activeId="spaces" onLogout={onLogout} />

      <div className="main-content setup-layout">
        {/* --- HEADER DARK SECTION --- */}
        <div className="setup-header">
          <button className="back-btn" onClick={onBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          </button>
          
          <div className="header-titles">
            <h2>Create a new space</h2>
            <p>Add the first details</p>
          </div>

          <div className="step-indicator">
            Step <strong>1 | 7</strong>
          </div>
        </div>

        {/* --- MAIN CARD --- */}
        <div className="setup-body">
          <div className="house-card-wrapper">
            <div className="house-preview">
              <img src={housePreview} alt="House Preview" />
              <button className="upload-icon-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a73e8" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
              </button>
            </div>

            <div className="input-section">
              <label>What's your house name?</label>
              <input 
                type="text" 
                value={houseName} 
                onChange={(e) => setHouseName(e.target.value)}
                className="house-input"
              />
              
              <div className="suggestions">
                <span>No inspiration? Try one of these names.</span>
                <div className="chips">
                  {suggestions.map((name) => (
                    <button 
                      key={name} 
                      className="chip-btn"
                      onClick={() => setHouseName(name)}
                    >
                      {name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- FOOTER ACTION BAR --- */}
        <div className="setup-footer">
          <div className="footer-content">
            <span className="footer-hint">Name your new space</span>
            <button className="primary-btn continue-btn" onClick={onContinue}>
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupSpace;